import { getEventOrigin } from '../eventOrigin';
import { formatInspectorState } from '../format';
import type { InspectorEntry } from '../protocol';

export interface MachineEventTelemetry {
  name: string;
  properties: Record<string, boolean | number | string>;
}

/**
 * Maps one inspector entry onto one App Insights custom event.
 *
 * The scalar fields are flattened so they can be filtered on directly in KQL; `entry`
 * carries the whole record so the inspector can rehydrate a byte-identical replay. A
 * single entry is ~700 bytes against an 8192-character property cap, so nothing has to
 * be dropped or chunked.
 */
export const buildMachineEventTelemetry = (
  entry: InspectorEntry,
  sinceStartMs: number,
): MachineEventTelemetry => {
  const { label } = getEventOrigin(entry.event.type);

  return {
    name: `VoiceLive:${label}:${entry.event.type}`,
    properties: {
      ...entry.context,
      // ICE_SERVERS repeats hasTurnServer/iceServerCount; the event's own values win.
      ...entry.event.details,
      actions: entry.actions.join(','),
      actorId: entry.actorId,
      entry: JSON.stringify(entry),
      origin: label,
      seq: entry.sequence,
      sinceStartMs,
      state: formatInspectorState(entry.state),
      status: entry.status,
      tier: 'machine',
    },
  };
};
